import { CreateConnectionMediumDeviceDto, RowConnectionMediumDeviceDto, UpdateConnectionMediumDeviceDto } from "@/dtos";
import { ConnectionMedium, ConnectionMediumDevice, Device } from "@/entities";

export const formatRowConnectionMediumDevice = (vehicleCompanies: ConnectionMediumDevice[]): RowConnectionMediumDeviceDto[] => {
    return vehicleCompanies.map((r) => {
        const row: RowConnectionMediumDeviceDto = {
            id: r.id,
            device_id: r.device.id,
            device_name: r.device.name ?? '',
            connection_medium_id: r.connection_medium.id,
            is_principal: r.is_principal,
            is_active: r.is_active,
            principal: (r.is_principal) ? 'Principal' : 'Secundaria',
            active: (r.is_active) ? 'Activo' : 'Inactivo'
        }
        return row;
    });
}


export const formatConnectionMediumDeviceDto = async (rowConnectionMediumDeviceDto: RowConnectionMediumDeviceDto, adminId: number, idConnectionMediumDevice: number, isCreate: boolean) => {
    const device = { id: rowConnectionMediumDeviceDto.device_id } as Device;
    const connection_medium = { id: idConnectionMediumDevice } as ConnectionMedium;

    const connectionMediumDeviceDto = {
        connection_medium: connection_medium,
        device: device,
        is_principal: rowConnectionMediumDeviceDto.is_principal
    }

    return (isCreate) ? connectionMediumDeviceDto as CreateConnectionMediumDeviceDto :
        connectionMediumDeviceDto as UpdateConnectionMediumDeviceDto
}